// extracted by mini-css-extract-plugin
export default {"loadMoreButton":"_base-load-more_loadMoreButton_VhfI4","iconArrowDown":"_base-load-more_iconArrowDown_vLnaB"};